/**
 * Invoyss wordmark geometry — shared by web, mobile, and the SVG
 * generator (`scripts/generate-invoyss-logo.mjs`).
 *
 * The mark is Inter Tight regular weight + a trailing accent dot,
 * baseline-aligned to the bottom of the cap height. Sizes mirror the
 * mobile welcome splash (lg) and BusinessGate splash (md).
 */
export const INVOYSS_WORDMARK = 'Invoyss';

export type InvoyssLogoSize = 'sm' | 'md' | 'lg';

export type InvoyssLogoMetrics = {
  fontSize: number;
  dot: number;
  gap: number;
  /** Space below the dot's center to align with the word baseline. */
  dotOffset: number;
  letterSpacing: string;
  lineHeight: number;
};

export const INVOYSS_LOGO_SIZES: Record<InvoyssLogoSize, InvoyssLogoMetrics> = {
  /** Sidebar, compact headers, public invoice chrome. */
  sm: {
    fontSize: 18,
    dot: 6,
    gap: 5,
    dotOffset: 5,
    letterSpacing: '-0.04em',
    lineHeight: 1.05,
  },
  /** Splash / auth gate — matches mobile BusinessGate. */
  md: {
    fontSize: 32,
    dot: 7,
    gap: 6,
    dotOffset: 7,
    letterSpacing: '-0.03em',
    lineHeight: 1.06,
  },
  /** First-launch welcome hero — matches mobile `(auth)/welcome`. */
  lg: {
    fontSize: 64,
    dot: 12,
    gap: 8,
    dotOffset: 12,
    letterSpacing: '0',
    lineHeight: 1.09,
  },
};

/** Editorial palette defaults for static SVG export (favicon, OG). */
export const INVOYSS_LOGO_STATIC_COLORS = {
  ink: '#1a1612',
  accent: '#0ea5a5',
} as const;
